import { withState } from 'recompose';

export default withState('currency', 'updateCurrency', 'CAD');
